import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  warning: {
    alignItems: 'center',
    fontSize: 16,
    lineHeight: 1.4
  },
  button: {
    ...reskinStyles(theme, {
      '&&': { backgroundColor: theme.colorPalette.green_100, color: theme.colorPalette.white },
      '&&:hover': { backgroundColor: theme.colorPalette.green_90, color: theme.colorPalette.white }
    }),
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    fontSize: 16,
    width: 150
  }
});

export default makeStyles(styles);
